export default "__VITE_ASSET__DVkp6N94__"